import {
  configure,
  action,
  decorate,
  observable,
  runInAction,
  reaction,
} from 'mobx';
import Cookies from 'js-cookie';
import history from '../browserHistory';
import {
  setStoredValue,
  setStoredSessionValue,
  removeStoredSessionValue,
} from '../shared/utils/localStorage';
import { sessionTokenKey } from '../shared/constants';

configure({ enforceActions: 'always' });

export default class AuthStore {
  constructor() {
    this.initialize();
    runInAction('AuthStore', () => {
      this.connection = null;
      this.errorMessage = null;
      this.settings = null;
    });

    reaction(
      () => this.settings,
      () => setStoredSessionValue(sessionTokenKey, this.settings.sessionToken),
    );
  }

  initialize = () => {
    this.setProperty('memberName', null);
    this.setProperty('connectionInfo', null);
  };

  setSettings = (data) => {
    this.settings = data;
    // console.log('setSettings', data);
  };

  logOut = () => {
    this.connection = null;
    Cookies.remove('__session');
    // window.localStorage.removeItem(sessionTokenKey);
    removeStoredSessionValue(sessionTokenKey);
    history.push('/');
    console.log('🔓 User logged out');
  };

  setProperty = (key, val) => {
    this[key] = val;
  };
}

decorate(AuthStore, {
  memberName: observable,
  connectionInfo: observable,
  errorMessage: observable,
  logOut: action,
  setProperty: action,
  settings: observable,
  setSettings: action,
});
